import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonFunction } from 'src/app/grievance/common-function';
import { Board, Departments } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';

import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { EscalationDurationService } from '../escalation-duration.service';

@Component({
  selector: 'app-update-escalation-duration',
  templateUrl: './update-escalation-duration.component.html',
  styleUrls: ['./update-escalation-duration.component.scss'],
})
export class UpdateEscalationDurationComponent implements OnInit {
  id: any;
  myid: any;
  fkGtId: any;
  progressSpinnerDialog: any = null;
  isSubmitDisabled: boolean = false;

  levels: any = [];
  Excellationdays: any = []

  firstFormGroup = this._formBuilder.group({
    grievanceTypeCtrl: [{ value: null, disabled: true }],
    departmentCtrl: [{ value: null, disabled: true }],
    boardCtrl: [{ value: null, disabled: true }],
    levelCtrl: [{ value: null, disabled: true }],
    boardNameCtrl: [{ value: null, disabled: true }],
    departmentNameCtrl: [{ value: null, disabled: true }],
    durationCtrl: [],
  })

  protected _onDestroy = new Subject<void>();

  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);

  constructor(public escalationService: EscalationDurationService,
    public _formBuilder: FormBuilder,
    private commonFunction: CommonFunction,
    public router: Router,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');
    this.levels = this.commonFunction.getLevels()
    this.Excellationdays = this.commonFunction.getEscalationDays()
    this.loadPredata()
  }


  async loadPredata() {
    const data = {
      'pkEsId': this.id
    }
    this.displayProgressSpinner();
    const response: any = await this.escalationService.getOneGrievanceEscalation(data);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      this.selectBoard(response.fkBdid)
      if (response.status == ProjectConstants.responseStatusSuccess) {
        this.fkGtId = response.fkGtId
        this.firstFormGroup.setValue({
          grievanceTypeCtrl: response.grievanceType,
          departmentCtrl: response.fkDepid,
          boardCtrl: response.fkBdid,
          levelCtrl: response.esLevel,
          durationCtrl: response.esDays,
          boardNameCtrl: response.boardName,
          departmentNameCtrl: response.departmentName
        })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }


  async updateForm() {
    if (this.firstFormGroup.valid) {
      const data = {
        'pkEsId': this.id,
        'fkDepid': this.firstFormGroup.controls['departmentCtrl'].value,
        'fkBdid': this.firstFormGroup.controls['boardCtrl'].value,
        'esLevel': this.firstFormGroup.controls['levelCtrl'].value,
        'esDays': this.firstFormGroup.controls['durationCtrl'].value,
        'fkGtId': this.fkGtId
      }
      this.displayProgressSpinner();
      const response: any = await this.escalationService.updateGrievanceEscalation(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if (response.status == ProjectConstants.responseStatusSuccess) {
          await this.commonFunction.successToast(ProjectConstants.esacalationUpdateSuccessMsg, false, "")
          this.router.navigate(['secure/list-escalation-duration/' + this.fkGtId])
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //department type filter
  protected filtereDepartments() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(department => department.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(
      this.boards.filter(board => board.boardName.toLowerCase().indexOf(search) > -1)
    );
  }
  //


  async selectBoard(boards: any) {
    this.displayProgressSpinner();
    const response: any = await this.escalationService.loadDepartments(boards);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.departments = response;
          this.departmentCtrl.setValue(this.departments[10]);
          this.filteredDepartment.next(this.departments.slice());
          this.departmentFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filtereDepartments();
            })
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      }
      else {
       this.departments=[]
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }


  async loadBoards() {
    //call to load board
    this.displayProgressSpinner();
    const response: any = await this.escalationService.loadBoard();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.boards = response
        //set boards in array  
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards.slice());
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
        //
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }

  escalationDurationList() {
    this.router.navigate(['secure/list-escalation-duration/' + this.fkGtId])
  }
}




